import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { freeOfferRedeem as freeOfferRedeemAPI } from "@/services/apiOffer";

export function useFreeOfferRedeem() {
    const queryClient = useQueryClient();
    const {
        mutate: freeOfferRedeem,
        isPending,
        error,
    } = useMutation({
        mutationFn: freeOfferRedeemAPI,
        onSuccess: () => {
            toast.success("تم إضافه العرض بنجاح");

            queryClient.invalidateQueries({ active: true });
        },

        onError: (err) => {
            console.log(err);
            toast.error(err.response.data.message);
        },
    });

    return { freeOfferRedeem, isPending, error };
}
